import React from 'react';
import { useSelector } from 'react-redux';

import EditWallet from './EditWallet';
import store from '../../../store';

function EditWalletContainer(props) {
  const walletContent = useSelector((state) => state.wallet.walletContent);
  const walletTotal = useSelector(store.select.wallet.walletTotal);
  const onWalletAdd = store.dispatch.wallet.walletAdd;
  const onWalletSub = store.dispatch.wallet.walletSub;
  return (
    <EditWallet
      onWalletAdd={onWalletAdd}
      onWalletSub={onWalletSub}
      walletContent={walletContent}
      walletTotal={walletTotal}
      {...props}
    />
  );
}

export default EditWalletContainer;
